import { TextField as MuiTextField } from "@material-ui/core";
import { rv } from "../../tokens";
import FieldShell from "./FieldShell";

interface Props {
  label?: string;
  value: string | number | undefined;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  type?: string;
  placeholder?: string;
  disabled?: boolean;
}

export default function TextField({
  label,
  value,
  onChange,
  error,
  required,
  type = "text",
  placeholder,
  disabled,
}: Props) {
  return (
    <FieldShell label={label} required={required} error={error}>
      <MuiTextField
        variant="outlined"
        size="small"
        fullWidth
        type={type}
        placeholder={placeholder}
        value={value ?? ""}
        disabled={disabled}
        error={Boolean(error)}
        inputProps={{ style: { fontFamily: rv.fontSans } }}
        onChange={(event) => onChange(event.target.value)}
      />
    </FieldShell>
  );
}
